import { headerHeight } from "../../constants";

export const styles = {
  appBarContainer: {
    display: "flex",
  },
  toolbarBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    maxWidth: "1200px",
    paddingLeft: "20px",
    paddingRight: "30px",
  },
  header: {
    height: headerHeight,
    boxShadow: "none",
    backgroundColor: "events.grayShade1",
    color: "text.primary",
  },
  logo: {
    position: { xs: "relative", sm: "absolute" },
    left: { xs: "10px", sm: "33px" },
    width: "40px",
    height: "40px",
    padding: 0,
    marginLeft: { xs: 0, sm: "unset" },
  },
  titleContainer: {
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: {
    lineHeight: "22px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingLeft: {
      sm: 0,
      md: "2rem",
      lg: 0,
    },
  },
  rightAdornment: {
    display: "flex",
    alignItems: "center",
    height: "inherit",
    "& > :not(:last-child)": {
      marginRight: "30px",
    },
  },
  profilePicture: {
    width: "40px",
    height: "40px",
  },
  companyProfile: {
    minWidth: "190px",
    maxWidth: "190px",
  },
  logoContainer: {
    paddingRight: "20px",
  },
};
